import { render } from "./HomeSso.vue?vue&type=template&id=44ad44df"
import script from "./HomeSso.vue?vue&type=script&lang=ts"
export * from "./HomeSso.vue?vue&type=script&lang=ts"

import "./HomeSso.vue?vue&type=style&index=0&id=44ad44df&lang=css"
script.render = render

export default script